import Text from "@/components/atoms/Text";
import classNames from "classnames";
import Image from "next/image";
import Link from "next/link";
import { useState } from "react";

const AccordionItems = ({ item, key }) => {
  const [active, setActive] = useState(false);

  return (
    <div
      key={"faq-" + (key + 1)}
      className="border border-b-1 border-x-0 py-4 base-grid"
    >
      <div className="col-span-12 base-grid">
        <div
          onClick={() => (active ? setActive(false) : setActive(true))}
          className="col-span-10 cursor-pointer "
        >
          <Text className="font-title text-base md:text-lg text-main-grey">
            {item?.question}
          </Text>
        </div>
        <div
          className="col-span-2 mr-3 ml-auto grid"
          onClick={() => (active ? setActive(false) : setActive(true))}
        >
          {!active && (
            <Image
              src="/images/faqs/arrow-down.svg"
              alt="arrow-down"
              width={20}
              height={10}
              className="my-auto cursor-pointer"
            />
          )}
          {active && (
            <Image
              src="/images/faqs/arrow-up.svg"
              alt="arrow-up"
              width={20}
              height={10}
              className="my-auto cursor-pointer"
            />
          )}
        </div>
      </div>
      <div
        className={classNames(
          !active && "hidden",
          "col-span-12 lg:col-span-10 whitespace-pre-line inline-block"
        )}
      >
        <Text className=" font-text text-main-grey text-[12px] lg:text-[16px]">
          {item?.answer}
          <span>
            {item?.hasLink && (
              <Link
                href={item?.link?.href}
                className="font-text text-main-blue inline"
              >
                {item?.link?.label}
              </Link>
            )}
          </span>
          {item?.textAfterLink && <span>{item?.textAfterLink}</span>}
        </Text>
      </div>
    </div>
  );
};
export default AccordionItems;
